module.exports = __webpack_public_path__ + "static/media/SuddenlyaMurderBookCover.a75e7e9a.jpg";